// extracted by mini-css-extract-plugin
module.exports = {"container":"HistoryTable_container___uSsB","header":"HistoryTable_header__3kgBC","headerItem":"HistoryTable_headerItem__2UBoM","message":"HistoryTable_message__34jQi"};